module.exports = __webpack_public_path__ + "media/images/photo/plans/common/img_konin-photo-bb583e59b45d7341d0271652bb2fed98.jpg";